import type { DataUIPart, FileUIPart, TextUIPart } from "ai";
import { studioDataUIConverter } from "apprentices/dataParts/converters";
import type { StudioDataUIParts } from "apprentices/dataParts/types";
import { buildDatetimeContext } from "apprentices/datetime";
import {
  CONTEXT_CLOSE_TAG,
  CONTEXT_OPEN_TAG,
} from "forest/chat/workspace-context";

/**
 * The user-message parts a send's pane state becomes: one hidden
 * `<workspace_context>` text block, led by the clock, then any pictures (a
 * sketch screenshot) as file parts beside it, since an image has no place in
 * text.
 */
export function workspaceContextParts(
  now: Date,
  parts: DataUIPart<StudioDataUIParts>[],
): (TextUIPart | FileUIPart)[] {
  const converted = parts.map(studioDataUIConverter);
  const texts = [
    buildDatetimeContext(now),
    ...converted.filter((p) => p?.type === "text").map((p) => p.text),
  ];
  return [
    {
      type: "text",
      text: `${CONTEXT_OPEN_TAG}\n${texts.join("\n\n")}\n${CONTEXT_CLOSE_TAG}`,
    },
    ...converted.filter((p) => p?.type === "file"),
  ];
}
